import {
  getPrivateStepRoute,
  ACTIVE_PRIVATE_HOSPITAL_CONFIG,
} from '../config/privateBooking';

export const ROOT_ROUTE = '';
export const DOCTORS_ROUTE = `${ROOT_ROUTE}/psychologists`;
export const SPECIALITIES_ROUTE = `${ROOT_ROUTE}/specialities`;
export const PATIENT_DETAILS = `${ROOT_ROUTE}/patient-details`;
export const MEDICARE = `${ROOT_ROUTE}/medicare`;
export const PAYMENT = `${ROOT_ROUTE}/payment`;
export const DOCUMENTS = `${ROOT_ROUTE}/documents`;
export const Confirmation = `${ROOT_ROUTE}/booking-confirmation`;
export const THANKS = `${ROOT_ROUTE}/thanks`;

export const PHN_ROUTE = ACTIVE_PRIVATE_HOSPITAL_CONFIG.baseRoute;

export const PRIVATE_STEP_ROUTES = {
  psychologists: getPrivateStepRoute('psychologists')!,
  patientDetails: getPrivateStepRoute('patientDetails')!,
  documents: getPrivateStepRoute('documents')!,
  gpDetails: getPrivateStepRoute('gpDetails'),
  refererDetails: getPrivateStepRoute('refererDetails'),
  summary: getPrivateStepRoute('summary')!,
  thanks: getPrivateStepRoute('thanks')!,
};

export const PHN_DOCTORS_ROUTE = PRIVATE_STEP_ROUTES.psychologists;
export const PHN_PATIENT_DETAILS = PRIVATE_STEP_ROUTES.patientDetails;
export const PHN_DOCUMENTS = PRIVATE_STEP_ROUTES.documents;
export const PHN_GP_DETAILS = PRIVATE_STEP_ROUTES.gpDetails;
export const PHN_REFERER_DETAILS = PRIVATE_STEP_ROUTES.refererDetails;
export const PHN_CONFIRMATION = PRIVATE_STEP_ROUTES.summary;
export const PHN_THANKS = PRIVATE_STEP_ROUTES.thanks;

export const STANDALONE_PATHS = [DOCTORS_ROUTE, `${DOCTORS_ROUTE}/`, THANKS, PHN_THANKS];
